<template>
  <!--Filters Buttons-->
  <div class="md-layout-item md-size-15">
    <md-button class="icon-button-size-40 md-icon-button icon-button"
               :class="isRaised(item)"
               :diabled="disabled">

      <md-icon class="color-red fa fa-pencil-square-o button-icon" />
    </md-button>
  </div>
</template>

<script>

  export default {
    name: "DisconectedIcon",
    components: {
    },
    props: {
      isRaised: {
        type: Function,
        reuired: true
      },
      item: {
        type: Boolean,
        reuired: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {}
  };

</script>
<style src="../filters.css"></style>
